import React, { PureComponent } from "react";
import isEqual from "lodash/isEqual";
import "../styles/components/Button.css";

class Button extends PureComponent {
    static defaultProps = {
        color: "primary", // primary | accent | contrast
        dense: false,
        disabled: false,
        href: null
    };

    constructor(props) {
        super(props);
        this.state = {
            mouseDown: false
        };
    }

    get effectiveWrapperClass() {
        return ["Button-wrapper", this.props.wrapperClass]
            .filter(Boolean)
            .join(" ");
    }

    get effectiveButtonClass() {
        return [
            "Button",
            this.props.disabled
                ? "Button-disabled"
                : `Button-${this.props.color}`,
            this.props.buttonClass
        ]
            .filter(Boolean)
            .join(" ");
    }

    renderButton() {
        const onClick = this.props.onClick ? this.props.onClick : null;
        const disabled = this.props.disabled;

        // Buttons normally slide down about 5 pixels onMouseDown, but that can slide them
        // slightly out of the way and lead to discarded clicks. To solve that issue, I wrap
        // them in form-fitting divs and capture the mouse up event
        return (
            <div className={this.effectiveWrapperClass} onMouseUp={onClick}>
                <button
                    disabled={disabled}
                    className={this.effectiveButtonClass}
                    onClick={onClick}
                    onMouseUp={e => e.stopPropagation()}
                    style={this.props.style || {}}
                >
                    {this.props.children}
                </button>
            </div>
        );
    }

    renderLink() {
        return (
            <a
                style={this.props.disabled ? { pointerEvents: "none" } : {}}
                href={this.props.href}
                className={this.effectiveButtonClass}
            >
                {this.props.children}
            </a>
        );
    }

    render() {
        const element = !this.props.href ? "button" : "a";

        return isEqual(element, "button")
            ? this.renderButton()
            : this.renderLink();
    }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js